import { useEffect, useRef, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useForm, SubmitHandler } from "react-hook-form";
import { LoadingButton } from "../../../../../components/button/Button";
import Condition from "../../../../../components/condition/Condition";
import { useGenerateArrayFromObj } from "../../../../../components/input/hook/useGenerateOptions2";
import ProductWithPriceInvoice, {
  ProductWithPriceInvoiceData,
} from "../../../../../components/product/ProductWithPrice-v2";
import { useToast } from "../../../../../context/toast/ToastContext";
import { MainContainerForm } from "../../../../../styles/Main.styles";
import { useGetInvoiceConstant } from "../../../api/invoice/constant/resolver";
import { useCancelInvoice, usePayInvoice } from "../../../api/invoice/resolver";
import GrosirInput from "../../__component/GrosirInput";
import PaymentMethodInput from "../../__component/PaymentMethodInput";
import PrintInvoice from "../../__component/PrintInvoice";
import RetailInput from "../../__component/RetailInput";
import Input from "../../../../../components/input/Input-v2";
import { M_InvoiceDetail } from "../../../type/Invoice.type";
import { ModalFC } from "../../../../../components/modal/Modal";
import {
  EditableQuantityTableConfig,
  // ReturTableConfig,
  ReturTableListConfig,
} from "../../../tableConfig/TableConfig";
// import { useCreateRetur } from "../../../api/invoice/retur/resolver";
import { FromStringToDate } from "../../../../../utils/Helper";
import TableFC from "../../../../../components/table/Table";

export interface Form_Create_Invoice {
  invoice_date: string;
  invoice_type: string;
  payment_method_id: string;
  invoice_status: string;
  product_list: any;
  customer_name: string;
  customer_address?: string;
  customer_phone_number?: string;
  sub_dealer_id?: string;
  payment_due_date?: string;
  description?: string;
  descriptionRetur: string;
}

export interface Form_Create_Retur {
  return_invoice_date: string;
  invoice_id: string;
  payment_method_id: string;
  product_list: any;
  description: string;
}

interface Form {
  dataInvoice: M_InvoiceDetail;
}

export default function FormBelumLunas({ dataInvoice }: Form) {
  const { show } = useToast();
  const refForm = useRef<any>();
  const { control, handleSubmit, setValue, watch, getValues, trigger } =
    useForm<Form_Create_Invoice>({
      defaultValues: {
        customer_name: "",
      },
    });
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataInvoiceType } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.type,
  });
  const { data: dataInvoiceStatus } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.status,
  });
  const { mutate: mutatePayInvoice, isLoading: loadingPay } = usePayInvoice();
  // const { mutate: mutateRetur, isLoading: loadingRetur } = useCreateRetur();
  const { mutate: mutateCancel, isLoading: loadingCancel } = useCancelInvoice();
  const [productWithPriceData, setProductWithPriceData] = useState<
    ProductWithPriceInvoiceData[]
  >([]);
  const [showModal, setShowModal] = useState(false);
  const [isReturMode, setIsReturMode] = useState(false);
  const isFetching = fetchInvoiceConstant;
  const { body: bodyListRetur, header: headerListRetur } =
    ReturTableListConfig();
  // const {
  //   body: bodyRetur,
  //   header: headerRetur,
  //   lastRow: lastRowRetur,
  // } = ReturTableConfig({
  //   grandTotal: productWithPriceData.reduce((acc, item) => {
  //     return acc + item.price * item.quantity;
  //   }, 0),
  //   onRetuQuantityChange: (id, qty) => {
  //     setProductWithPriceData((prev) =>
  //       prev.map((item) => {
  //         if (item.id === id) {
  //           item.returQuantity = qty;
  //         }
  //         return item;
  //       })
  //     );
  //   },
  // });
  const {
    body: bodyEditable,
    header: headerEditable,
    lastRow: lastRowEditable,
  } = EditableQuantityTableConfig({
    grandTotal: productWithPriceData.reduce((acc, item) => {
      return acc + item.price * item.quantity;
    }, 0),
    onQuantityChange: (id, qty) => {
      setProductWithPriceData((prev) =>
        prev.map((item) => {
          if (item.id === id) {
            item.quantity = qty;
          }
          return item;
        })
      );
    },
  });
  const loading = loadingPay || loadingCancel;

  useEffect(() => {
    if (dataInvoice) {
      setValue("customer_name", dataInvoice.customer_name);
      setValue("payment_method_id", dataInvoice.payment_method_id);
      setValue(
        "payment_due_date",
        FromStringToDate(dataInvoice.payment_due_date) || ""
      );
      setValue("customer_address", dataInvoice.customer_address || "");
      setValue("description", dataInvoice.description);
      setValue(
        "customer_phone_number",
        dataInvoice.customer_phone_number || ""
      );
      setValue("sub_dealer_id", dataInvoice.sub_dealer_id);
      setProductWithPriceData(
        dataInvoice.invoice_detail.map((item) => {
          return {
            id: item.id,
            name: item.product.product_type_name,
            price: item.price,
            quantity: item.quantity,
            unitType: item.product.unit_type,
          };
        })
      );
    }
  }, [dataInvoice]);

  useEffect(() => {
    if (dataInvoiceConstant) {
      setValue("invoice_type", dataInvoice.invoice_type);
      setValue("invoice_status", dataInvoice.status);
    }
  }, [dataInvoiceConstant]);

  const handleFormSubmit: SubmitHandler<Form_Create_Invoice> = (data) => {
    if (isReturMode) {
      const currentDate = new Date().toISOString();
      const productList: any[] = [];
      productWithPriceData.forEach((item) => {
        productList.push({
          invoice_detail_id: item.id,
          quantity: item.returQuantity,
        });
      });
      // mutateRetur({
      //   description: data.descriptionRetur,
      //   invoice_id: dataInvoice.id.toString(),
      //   payment_method_id: data.payment_method_id,
      //   return_invoice_date: FromStringToDate(currentDate, true),
      //   product_list: JSON.stringify(productList),
      // });
    } else {
      mutatePayInvoice({
        invoice_id: dataInvoice.id.toString(),
        payment_method_id: data.payment_method_id,
      });
    }
  };

  const handleFormCancel = () => {
    if (confirm("Apakah anda yakin ?")) {
      mutateCancel({
        description: "",
        invoice_id: dataInvoice.id.toString(),
      });
    }
  };

  const handleOpenPaymentConfimation = () => {
    const dataProductList = getValues("product_list");
    if (!isReturMode && dataProductList.length <= 0) {
      show("Tidak ada barang yang dipilih", "warning");
      return;
    }
    if (!isReturMode && getValues("payment_method_id") === null) {
      show("Mohon memilih pembayaran", "warning");
      return;
    }
    refForm.current.requestSubmit();
  };

  return (
    <form ref={refForm} onSubmit={(e) => handleSubmit(handleFormSubmit)(e)}>
      <MainContainerForm mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Input.Text
              showAsStatic
              label="Nomor Invoice"
              value={dataInvoice.invoice_number}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleFormCancel()}
            >
              Batalkan Nota
            </Button>
          </Grid>
          <Grid item xs={12}>
            <PrintInvoice data={dataInvoice} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_type"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={isFetching}
                  label="Tipe Invoice"
                  options={dataInvoiceType || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_status"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  isFetching={isFetching}
                  label="Status Invoice"
                  options={dataInvoiceStatus || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Condition.IF
            condition={
              watch("invoice_status") !== undefined &&
              watch("invoice_status") ===
                dataInvoiceConstant?.status["Belum Lunas"]
            }
          >
            <Grid item xs={12} md={12}>
              <Input.Controller
                control={control}
                name="payment_due_date"
                render={(field) => (
                  <Input.Date
                    showAsStatic
                    isFetching={isFetching}
                    label="Tanggal Jatuh Tempo"
                    value={field.value}
                    onChange={(e) => field.onChange(e)}
                  />
                )}
              />
            </Grid>
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Grosir
            }
          >
            <GrosirInput disable={true} control={control} />
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Retail
            }
          >
            <RetailInput
              disable={true}
              control={control}
              isFetching={isFetching}
            />
          </Condition.IF>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="description"
              render={(field) => (
                <Input.TextArea
                  showAsStatic
                  isFetching={isFetching}
                  label="Catatan"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
          {/* {isReturMode && (
            <Grid item xs={12}>
              <Input.Controller
                control={control}
                name="descriptionRetur"
                rules={{ required: "Kolom ini tidak boleh kosong" }}
                render={(field, fieldState) => (
                  <Input.TextArea
                    isFetching={isFetching}
                    label="Catatan Retur"
                    value={field.value}
                    onChange={(e) => field.onChange(e)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          )} */}
        </Grid>
      </MainContainerForm>
      {dataInvoice.return_invoice && dataInvoice.return_invoice.length > 0 && (
        <MainContainerForm mb={2}>
          <TableFC
            showIndex
            body={bodyListRetur}
            head={headerListRetur}
            data={dataInvoice.return_invoice}
          />
        </MainContainerForm>
      )}
      <MainContainerForm>
        <ProductWithPriceInvoice
          invoiceType={watch("invoice_type")}
          dataProduct={productWithPriceData}
          onChange={(e) => setValue("product_list", e)}
          body={bodyEditable}
          header={headerEditable}
          lastRowRender={lastRowEditable}
        />
        <Box display={"flex"} justifyContent={"flex-end"} mt={2} gap={2}>
          {isReturMode ? (
            <LoadingButton
              isLoading={false}
              text={"Retur"}
              onClick={async () => {
                setShowModal(true);
              }}
            />
          ) : (
            <LoadingButton
              isLoading={false}
              text={"Bayar"}
              onClick={async () => {
                const isValid = await trigger([
                  "customer_name",
                  "invoice_status",
                  "invoice_type",
                ]);
                if (isValid) {
                  setShowModal(true);
                }
              }}
            />
          )}
        </Box>
      </MainContainerForm>
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Box minHeight={150}>
          <Typography variant="h6" mb={1}>
            Apakah anda yakin ?
          </Typography>
          {!isReturMode && (
            <PaymentMethodInput
              control={control}
              isPaymentForm={true}
              dataInvoiceConstant={dataInvoiceConstant}
              invoice_status={watch("invoice_status")}
            />
          )}
          <Box display={"flex"} justifyContent={"flex-end"} mt={2} gap={2}>
            <Button variant="outlined" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <LoadingButton
              onClick={() => handleOpenPaymentConfimation()}
              isLoading={loading}
              text={"Konfirmasi"}
            />
          </Box>
        </Box>
      </ModalFC>
    </form>
  );
}
